<span *ngIf="message.ownerId | isCurrentUser | async">Me</span>
<span *ngIf="!(message.ownerId | isCurrentUser | async)">{{ message.ownerName }}</span>
:
<ng-container [ngSwitch]="!!message.content">
  <span *ngSwitchCase="true">{{ message.content | textTruncate: 25 }}</span>
  <span *ngSwitchDefault>...</span>
</ng-container>
